//#region src/integrations/mcp/mcpTypes.ts
const MCP_INTEGRATION_ID = "mcp-integration";
const MCP_PUBLIC_INTEGRATION_SERVICE_IDENT = "org.greenhouse.integrations.mcp.IMcpPublicIntegrationService";

//#endregion
export { MCP_INTEGRATION_ID, MCP_PUBLIC_INTEGRATION_SERVICE_IDENT };
//# sourceMappingURL=mcpTypes.js.map